import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c617aa2&scoped=true&"
import script from "./index.ts?vue&type=script&lang=js&"
export * from "./index.ts?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5c617aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c617aa2",
  null
  
)

export default component.exports